import { RESET_USER } from ".";
import { methods } from "../constants/constants";
import { getExamenById } from "../utils/dataHandlers/ExamenesDataHandler";

export const types = {
  GET_EXAMENES_BEGINS: 'EXAMENES/GET_EXAMENES_BEGINS',
  GET_EXAMENES_SUCCESS: 'EXAMENES/GET_EXAMENES_SUCCESS',
  GET_EXAMENES_FAILURE: 'EXAMENES/GET_EXAMENES_FAILURE',
  GET_EXAMENES_UPDATE: 'EXAMENES/GET_EXAMENES_UPDATE',

  POST_EXAMENES_BEGINS: 'EXAMENES/POST_EXAMENES_BEGINS',
  POST_EXAMENES_SUCCESS: 'EXAMENES/POST_EXAMENES_SUCCESS',
  POST_EXAMENES_FAILURE: 'EXAMENES/POST_EXAMENES_FAILURE',
  RESET_POST_EXAMENES: 'EXAMENES/RESET_POST_EXAMENES',

  EDIT_EXAMENES_BEGINS: 'EXAMENES/EDIT_EXAMENES_BEGINS',
  EDIT_EXAMENES_SUCCESS: 'EXAMENES/EDIT_EXAMENES_SUCCESS',
  EDIT_EXAMENES_FAILURE: 'EXAMENES/EDIT_EXAMENES_FAILURE',
  RESET_EDIT_EXAMENES: 'EXAMENES/RESET_EDIT_EXAMENES',

  DELETE_EXAMENES_BEGINS: 'EXAMENES/DELETE_EXAMENES_BEGINS',
  DELETE_EXAMENES_SUCCESS: 'EXAMENES/DELETE_EXAMENES_SUCCESS',
  DELETE_EXAMENES_FAILURE: 'EXAMENES/DELETE_EXAMENES_FAILURE',
  RESET_DELETE_EXAMENES: 'EXAMENES/RESET_DELETE_EXAMENES',

  UPDATE_EXAMEN_BEGIN: 'EXAMENES/UPDATE_EXAMEN_BEGIN',
  UPDATE_EXAMEN_SUCCESS: 'EXAMENES/UPDATE_EXAMEN_SUCCESS',
  UPDATE_EXAMEN_FAILURE: 'EXAMENES/UPDATE_EXAMEN_FAILURE',
  RESET_UPDATE_EXAMEN: 'EXAMENES/RESET_UPDATE_EXAMEN',

  GET_VISIBILIDAD_EXTERNA_BEGINS: 'EXAMENES/GET_VISIBILIDAD_EXTERNA_BEGINS',
  GET_VISIBILIDAD_EXTERNA_SUCCESS: 'EXAMENES/GET_VISIBILIDAD_EXTERNA_SUCCESS',
  GET_VISIBILIDAD_EXTERNA_FAILURE: 'EXAMENES/GET_VISIBILIDAD_EXTERNA_FAILURE',
  RESET_GET_VISIBILIDAD_EXTERNA: 'EXAMENES/RESET_GET_VISIBILIDAD_EXTERNA',

  BATCH_GET_VISIBILIDAD_EXTERNA_BEGINS: 'EXAMENES/BATCH_GET_VISIBILIDAD_EXTERNA_BEGINS',
  BATCH_GET_VISIBILIDAD_EXTERNA_SUCCESS: 'EXAMENES/BATCH_GET_VISIBILIDAD_EXTERNA_SUCCESS',
  BATCH_GET_VISIBILIDAD_EXTERNA_FAILURE: 'EXAMENES/BATCH_GET_VISIBILIDAD_EXTERNA_FAILURE',
  RESET_BATCH_GET_VISIBILIDAD_EXTERNA: 'EXAMENES/RESET_BATCH_GET_VISIBILIDAD_EXTERNA',

  UPDATE_VISIBILIDAD_EXTERNA_BEGIN: 'EXAMENES/UPDATE_VISIBILIDAD_EXTERNA_BEGIN',
  UPDATE_VISIBILIDAD_EXTERNA_SUCCESS: 'EXAMENES/UPDATE_VISIBILIDAD_EXTERNA_SUCCESS',
  UPDATE_VISIBILIDAD_EXTERNA_FAILURE: 'EXAMENES/UPDATE_VISIBILIDAD_EXTERNA_FAILURE',
  RESET_UPDATE_VISIBILIDAD_EXTERNA: 'EXAMENES/RESET_UPDATE_VISIBILIDAD_EXTERNA',

  BATCH_UPDATE_VISIBILIDAD_EXTERNA_BEGIN: 'EXAMENES/BATCH_UPDATE_VISIBILIDAD_EXTERNA_BEGIN',
  BATCH_UPDATE_VISIBILIDAD_EXTERNA_SUCCESS: 'EXAMENES/BATCH_UPDATE_VISIBILIDAD_EXTERNA_SUCCESS',
  BATCH_UPDATE_VISIBILIDAD_EXTERNA_FAILURE: 'EXAMENES/BATCH_UPDATE_VISIBILIDAD_EXTERNA_FAILURE',
  RESET_BATCH_UPDATE_VISIBILIDAD_EXTERNA: 'EXAMENES/RESET_BATCH_UPDATE_VISIBILIDAD_EXTERNA',

  POST_SUBIR_EXAMEN_BEGINS: 'EXAMENES/POST_SUBIR_EXAMEN_BEGINS',
  POST_SUBIR_EXAMEN_SUCCESS: 'EXAMENES/POST_SUBIR_EXAMEN_SUCCESS',
  POST_SUBIR_EXAMEN_FAILURE: 'EXAMENES/POST_SUBIR_EXAMEN_FAILURE',
  RESET_POST_SUBIR_EXAMEN: 'EXAMENES/RESET_POST_SUBIR_EXAMEN',

  POST_SUBIR_EXAMENES_BATCH_BEGINS: 'EXAMENES/POST_SUBIR_EXAMENES_BATCH_BEGINS',
  POST_SUBIR_EXAMENES_BATCH_PROGRESS: 'EXAMENES/POST_SUBIR_EXAMENES_BATCH_PROGRESS',
  POST_SUBIR_EXAMENES_BATCH_SUCCESS: 'EXAMENES/POST_SUBIR_EXAMENES_BATCH_SUCCESS',
  POST_SUBIR_EXAMENES_BATCH_FAILURE: 'EXAMENES/POST_SUBIR_EXAMENES_BATCH_FAILURE',
  RESET_POST_SUBIR_EXAMENES_BATCH: 'EXAMENES/RESET_POST_SUBIR_EXAMENES_BATCH',
  
  GET_EXAMENES_ACADEMIA_USUARIO_BEGINS: 'EXAMENES/GET_EXAMENES_ACADEMIA_USUARIO_BEGINS',
  GET_EXAMENES_ACADEMIA_USUARIO_SUCCESS: 'EXAMENES/GET_EXAMENES_ACADEMIA_USUARIO_SUCCESS',
  GET_EXAMENES_ACADEMIA_USUARIO_FAILURE: 'EXAMENES/GET_EXAMENES_ACADEMIA_USUARIO_FAILURE',
  GET_EXAMENES_ACADEMIA_USUARIO_UPDATE: 'EXAMENES/GET_EXAMENES_ACADEMIA_USUARIO_UPDATE',

  CHECK_EXAMEN_GUARDADO_BEGINS: 'EXAMENES/CHECK_EXAMEN_GUARDADO_BEGINS',
  CHECK_EXAMEN_GUARDADO_SUCCESS: 'EXAMENES/CHECK_EXAMEN_GUARDADO_SUCCESS',
  CHECK_EXAMEN_GUARDADO_FAILURE: 'EXAMENES/CHECK_EXAMEN_GUARDADO_FAILURE',

  GET_EXAMEN_GUARDADO_BEGINS: 'EXAMENES/GET_EXAMEN_GUARDADO_BEGINS',
  GET_EXAMEN_GUARDADO_SUCCESS: 'EXAMENES/GET_EXAMEN_GUARDADO_SUCCESS',
  GET_EXAMEN_GUARDADO_FAILURE: 'EXAMENES/GET_EXAMEN_GUARDADO_FAILURE',
  SET_CONTINUAR_EXAMEN: 'EXAMENES/SET_CONTINUAR_EXAMEN',

  POST_GUARDAR_EXAMEN_BEGINS: 'EXAMENES/POST_GUARDAR_EXAMEN_BEGINS',
  POST_GUARDAR_EXAMEN_SUCCESS: 'EXAMENES/POST_GUARDAR_EXAMEN_SUCCESS',
  POST_GUARDAR_EXAMEN_FAILURE: 'EXAMENES/POST_GUARDAR_EXAMEN_FAILURE',
  RESET_POST_GUARDAR_EXAMEN: 'EXAMENES/RESET_POST_GUARDAR_EXAMEN',

  ELIMINAR_EXAMEN_GUARDADO_BEGINS: 'EXAMENES/ELIMINAR_EXAMEN_GUARDADO_BEGINS',
  ELIMINAR_EXAMEN_GUARDADO_SUCCESS: 'EXAMENES/ELIMINAR_EXAMEN_GUARDADO_SUCCESS',
  ELIMINAR_EXAMEN_GUARDADO_FAILURE: 'EXAMENES/ELIMINAR_EXAMEN_GUARDADO_FAILURE',
  RESET_ELIMINAR_EXAMEN_GUARDADO: 'EXAMENES/RESET_ELIMINAR_EXAMEN_GUARDADO',

}

export const initialState = {
  examenes: [],
  examenesFetching: false,
  examenesError: null,

  examenesStatus: null,
  examenesStatusData: null,
  examenesStatusFetching: false,
  examenesStatusError: null,

  examenesEditStatus: null,
  examenesEditStatusData: null,
  examenesEditStatusFetching: false,
  examenesEditStatusError: null,

  examenesDeleteStatus: null,
  examenesDeleteStatusData: null,
  examenesDeleteStatusMeta: null,
  examenesDeleteStatusFetching: false,
  examenesDeleteStatusError: null,

  updateExamenStatus: null,
  updateExamenStatusData: null,
  updateExamenStatusFetching: false,
  updateExamenStatusError: null,

  examenVisibilidadExterna: null,
  examenVisibilidadExternaFetching: false,
  examenVisibilidadExternaError: null,

  batchGetVisibilidadExternaData: null,
  batchGetVisibilidadExternaFetching: false,
  batchGetVisibilidadExternaError: null,

  updateVisibilidadExternaStatus: null,
  updateVisibilidadExternaStatusData: null,
  updateVisibilidadExternaStatusFetching: false,
  updateVisibilidadExternaStatusError: null,

  batchUpdateVisibilidadExternaStatus: null,
  batchUpdateVisibilidadExternaStatusData: null,
  batchUpdateVisibilidadExternaFetching: false,
  batchUpdateVisibilidadExternaError: null,

  subirExamenStatus: null,
  subirExamenData: [],
  subirExamenFetching: false,
  subirExamenError: null,

  subirExamenesBatchStatus: null,
  subirExamenesBatchData: [],
  subirExamenesBatchFetching: false,
  subirExamenesBatchError: null,
  subirExamenesBatchProgress: null,
  subirExamenesBatchMeta: null,

  examenesAcademiaUsuario: [],
  examenesAcademiaUsuarioFetching: false,
  examenesAcademiaUsuarioError: null,

  checkExamenGuardado: null,
  checkExamenGuardadoFetching: false,
  checkExamenGuardadoError: null,

  examenGuardado: null,
  examenGuardadoFetching: false,
  examenGuardadoError: null,
  continuarExamen: false,

  guardarExamenStatus: null,
  guardarExamenStatusData: null,
  guardarExamenStatusFetching: false,
  guardarExamenStatusError: null,

  eliminarExamenStatus: null,
  eliminarExamenStatusData: null,
  eliminarExamenStatusFetching: false,
  eliminarExamenStatusError: null,
}

const ExamenesReducer = (state = initialState, action) => {
  switch (action.type) {
    case RESET_USER:
      return initialState;
    case types.GET_EXAMENES_BEGINS: {
      return {
        ...state,
        examenesFetching: true,
        examenesError: null,
      }
    }
    case types.GET_EXAMENES_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        examenes: data,
        examenesFetching: false,
        examenesError: null,
      }
    }
    case types.GET_EXAMENES_FAILURE:
      return { 
        ...state,
        examenesFetching: false,
        examenesError: action.payload,
      }
    case types.GET_EXAMENES_UPDATE: {
      const { data, method } = action.payload;

      if (!data || !data.id) {
        return state;
      }

      const currentExamenes = Array.isArray(state.examenes) ? state.examenes : [];
      const exist = getExamenById(currentExamenes, data.id);

      if (method === methods.DELETE) {
        return {
          ...state,
          examenes: currentExamenes.filter((examen) => examen.id !== data.id),
          examenesFetching: false,
          examenesError: null,
        };
      }

      const updateExamenes = !exist
        ? [...currentExamenes, { ...data }]
        : currentExamenes.map((examen) => (
            examen.id === data.id
              ? {
                  ...examen,
                  ...data,
                }
              : examen
          ));

      return {
        ...state,
        examenes: updateExamenes,
        examenesFetching: false,
        examenesError: null,
      }
    }
    case types.POST_EXAMENES_BEGINS: {
      return {
        ...state,
        examenesStatusFetching: true,
        examenesStatusError: null,
      }
    }
    case types.POST_EXAMENES_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        examenesStatus: data.status,
        examenesStatusData: data.data,
        examenesStatusFetching: false,
        examenesStatusError: null,
      }
    }
    case types.POST_EXAMENES_FAILURE:
      return { 
        ...state,
        examenesStatusFetching: false,
        examenesStatusError: action.payload,
      }
      case types.RESET_POST_EXAMENES:
      return { 
        ...state,
        examenesStatus: null,
        examenesStatusData: null,
        examenesStatusFetching: false,
        examenesStatusError: null,
      }
    case types.EDIT_EXAMENES_BEGINS: {
      return {
        ...state,
        examenesEditStatusFetching: true,
        examenesEditStatusError: null,
      }
    }
    case types.EDIT_EXAMENES_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        examenesEditStatus: data.status,
        examenesEditStatusData: data.data,
        examenesEditStatusFetching: false,
        examenesEditStatusError: null,
      }
    }
    case types.EDIT_EXAMENES_FAILURE:
      return { 
        ...state,
        examenesEditStatusFetching: false,
        examenesEditStatusError: action.payload,
      }
    case types.RESET_EDIT_EXAMENES:
      return { 
        ...state,
        examenesEditStatus: null,
        examenesEditStatusData: null,
        examenesEditStatusFetching: false,
        examenesEditStatusError: null,
      }
    case types.DELETE_EXAMENES_BEGINS: {
      return {
        ...state,
        examenesDeleteStatusMeta: action.options || null,
        examenesDeleteStatusFetching: true,
        examenesDeleteStatusError: null,
      }
    }
    case types.DELETE_EXAMENES_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        examenesDeleteStatus: data.status,
        examenesDeleteStatusData: data.data,
        examenesDeleteStatusMeta: data.meta || null,
        examenesDeleteStatusFetching: false,
        examenesDeleteStatusError: null,
      }
    }
    case types.DELETE_EXAMENES_FAILURE:
      return { 
        ...state,
        examenesDeleteStatusFetching: false,
        examenesDeleteStatusError: action.payload,
      }
    case types.RESET_DELETE_EXAMENES:
      return { 
        ...state,
        examenesDeleteStatus: null,
        examenesDeleteStatusData: null,
        examenesDeleteStatusMeta: null,
        examenesDeleteStatusFetching: false,
        examenesDeleteStatusError: null,
      }
    case types.POST_SUBIR_EXAMEN_BEGINS: {
        return {
            ...state,
            subirExamenFetching: true,
            subirExamenError: null,
        }
    }
    case types.POST_SUBIR_EXAMEN_SUCCESS: {
        const data = action.payload;
        return {
            ...state,
            subirExamenStatus: data.status,
            subirExamenData: data.data,
            subirExamenFetching: false,
            subirExamenError: null,
        }
    }
    case types.POST_SUBIR_EXAMEN_FAILURE:
      return {
          ...state,
          subirExamenFetching: false,
          subirExamenError: action.payload,
      }
    case types.RESET_POST_SUBIR_EXAMEN:
      return { 
        ...state,
        subirExamenStatus: null,
        subirExamenData: null,
        subirExamenFetching: false,
        subirExamenError: null,
      }

    case types.POST_SUBIR_EXAMENES_BATCH_BEGINS:
      return {
        ...state,
        subirExamenesBatchStatus: null,
        subirExamenesBatchData: [],
        subirExamenesBatchFetching: true,
        subirExamenesBatchError: null,
        subirExamenesBatchProgress: action.progress || null,
        subirExamenesBatchMeta: null,
      }
    case types.POST_SUBIR_EXAMENES_BATCH_PROGRESS:
      return {
        ...state,
        subirExamenesBatchProgress: action.payload,
      }
    case types.POST_SUBIR_EXAMENES_BATCH_SUCCESS: {
      const data = action.payload;
      return {
        ...state,
        subirExamenesBatchStatus: data.status,
        subirExamenesBatchData: data.data,
        subirExamenesBatchFetching: false,
        subirExamenesBatchError: null,
        subirExamenesBatchProgress: data.progress || null,
        subirExamenesBatchMeta: data.meta || null,
      }
    }
    case types.POST_SUBIR_EXAMENES_BATCH_FAILURE:
      return {
        ...state,
        subirExamenesBatchFetching: false,
        subirExamenesBatchError: action.payload,
      }
    case types.RESET_POST_SUBIR_EXAMENES_BATCH:
      return {
        ...state,
        subirExamenesBatchStatus: null,
        subirExamenesBatchData: [],
        subirExamenesBatchFetching: false,
        subirExamenesBatchError: null,
        subirExamenesBatchProgress: null,
        subirExamenesBatchMeta: null,
      }

      case types.GET_EXAMENES_ACADEMIA_USUARIO_BEGINS: {
        return {
          ...state,
          examenesAcademiaUsuarioFetching: true,
          examenesAcademiaUsuarioError: null,
        }
      }
      case types.GET_EXAMENES_ACADEMIA_USUARIO_SUCCESS: {
        const data = action.payload;
        return {
          ...state,
          examenesAcademiaUsuario: data,
          examenesAcademiaUsuarioFetching: false,
          examenesAcademiaUsuarioError: null,
        }
      }
      case types.GET_EXAMENES_ACADEMIA_USUARIO_FAILURE:
        return { 
          ...state,
          examenesAcademiaUsuarioFetching: false,
          examenesAcademiaUsuarioError: action.payload,
      }
      case types.UPDATE_EXAMEN_BEGIN: {
        return {
          ...state,
          updateExamenStatusFetching: true,
          updateExamenStatusError: null,
        }
      }
      case types.UPDATE_EXAMEN_SUCCESS: {
        const data = action.payload;
        return {
          ...state,
          updateExamenStatus: data.status,
          updateExamenStatusData: data.data,
          updateExamenStatusFetching: false,
          updateExamenStatusError: null,
        }
      }
      case types.UPDATE_EXAMEN_FAILURE:
        return { 
          ...state,
          updateExamenStatusFetching: false,
          updateExamenStatusError: action.payload,
      }
      case types.RESET_UPDATE_EXAMEN:
        return { 
          ...state,
          updateExamenStatus: null,
          updateExamenStatusData: null,
          updateExamenStatusFetching: false,
          updateExamenStatusError: null,
      }
      case types.GET_VISIBILIDAD_EXTERNA_BEGINS:
        return {
          ...state,
          examenVisibilidadExternaFetching: true,
          examenVisibilidadExternaError: null,
        }
      case types.GET_VISIBILIDAD_EXTERNA_SUCCESS:
        return {
          ...state,
          examenVisibilidadExterna: action.payload,
          examenVisibilidadExternaFetching: false,
          examenVisibilidadExternaError: null,
        }
      case types.GET_VISIBILIDAD_EXTERNA_FAILURE:
        return {
          ...state,
          examenVisibilidadExternaFetching: false,
          examenVisibilidadExternaError: action.payload,
        }
      case types.RESET_GET_VISIBILIDAD_EXTERNA:
        return {
          ...state,
          examenVisibilidadExterna: null,
          examenVisibilidadExternaFetching: false,
          examenVisibilidadExternaError: null,
        }
      case types.BATCH_GET_VISIBILIDAD_EXTERNA_BEGINS:
        return {
          ...state,
          batchGetVisibilidadExternaData: null,
          batchGetVisibilidadExternaFetching: true,
          batchGetVisibilidadExternaError: null,
        }
      case types.BATCH_GET_VISIBILIDAD_EXTERNA_SUCCESS:
        return {
          ...state,
          batchGetVisibilidadExternaData: action.payload?.data || [],
          batchGetVisibilidadExternaFetching: false,
          batchGetVisibilidadExternaError: null,
        }
      case types.BATCH_GET_VISIBILIDAD_EXTERNA_FAILURE:
        return {
          ...state,
          batchGetVisibilidadExternaFetching: false,
          batchGetVisibilidadExternaError: action.payload,
        }
      case types.RESET_BATCH_GET_VISIBILIDAD_EXTERNA:
        return {
          ...state,
          batchGetVisibilidadExternaData: null,
          batchGetVisibilidadExternaFetching: false,
          batchGetVisibilidadExternaError: null,
        }
      case types.UPDATE_VISIBILIDAD_EXTERNA_BEGIN:
        return {
          ...state,
          updateVisibilidadExternaStatus: null,
          updateVisibilidadExternaStatusData: null,
          updateVisibilidadExternaStatusFetching: true,
          updateVisibilidadExternaStatusError: null,
        }
      case types.UPDATE_VISIBILIDAD_EXTERNA_SUCCESS: {
        const data = action.payload;
        return {
          ...state,
          examenVisibilidadExterna: data?.data || null,
          updateVisibilidadExternaStatus: data?.status,
          updateVisibilidadExternaStatusData: data?.data,
          updateVisibilidadExternaStatusFetching: false,
          updateVisibilidadExternaStatusError: null,
        }
      }
      case types.UPDATE_VISIBILIDAD_EXTERNA_FAILURE:
        return {
          ...state,
          updateVisibilidadExternaStatusFetching: false,
          updateVisibilidadExternaStatusError: action.payload,
        }
      case types.RESET_UPDATE_VISIBILIDAD_EXTERNA:
        return {
          ...state,
          updateVisibilidadExternaStatus: null,
          updateVisibilidadExternaStatusData: null,
          updateVisibilidadExternaStatusFetching: false,
          updateVisibilidadExternaStatusError: null,
        }
      case types.BATCH_UPDATE_VISIBILIDAD_EXTERNA_BEGIN:
        return {
          ...state,
          batchUpdateVisibilidadExternaStatus: null,
          batchUpdateVisibilidadExternaStatusData: null,
          batchUpdateVisibilidadExternaFetching: true,
          batchUpdateVisibilidadExternaError: null,
        }
      case types.BATCH_UPDATE_VISIBILIDAD_EXTERNA_SUCCESS: {
        const data = action.payload;
        return {
          ...state,
          batchUpdateVisibilidadExternaStatus: data?.status,
          batchUpdateVisibilidadExternaStatusData: data?.data,
          batchUpdateVisibilidadExternaFetching: false,
          batchUpdateVisibilidadExternaError: null,
        }
      }
      case types.BATCH_UPDATE_VISIBILIDAD_EXTERNA_FAILURE:
        return {
          ...state,
          batchUpdateVisibilidadExternaFetching: false,
          batchUpdateVisibilidadExternaError: action.payload,
        }
      case types.RESET_BATCH_UPDATE_VISIBILIDAD_EXTERNA:
        return {
          ...state,
          batchUpdateVisibilidadExternaStatus: null,
          batchUpdateVisibilidadExternaStatusData: null,
          batchUpdateVisibilidadExternaFetching: false,
          batchUpdateVisibilidadExternaError: null,
        }
      case types.CHECK_EXAMEN_GUARDADO_BEGINS: {
        return {
          ...state,
          checkExamenGuardadoFetching: true,
          checkExamenGuardadoError: null,
        }
      }
      case types.CHECK_EXAMEN_GUARDADO_SUCCESS: {
        const data = action.payload;
        return {
          ...state,
          checkExamenGuardado: data,
          checkExamenGuardadoFetching: false,
          checkExamenGuardadoError: null,
        }
      }
      case types.CHECK_EXAMEN_GUARDADO_FAILURE:
        return { 
          ...state,
          checkExamenGuardadoFetching: false,
          checkExamenGuardadoError: action.payload,
      }
      case types.GET_EXAMEN_GUARDADO_BEGINS: {
        return {
          ...state,
          examenGuardadoFetching: true,
          examenGuardadoError: null,
        }
      }
      case types.GET_EXAMEN_GUARDADO_SUCCESS: {
        const data = action.payload;
        return {
          ...state,
          examenGuardado: data,
          examenGuardadoFetching: false,
          examenGuardadoError: null,
        }
      }
      case types.GET_EXAMEN_GUARDADO_FAILURE:
        return { 
          ...state,
          examenGuardadoFetching: false,
          examenGuardadoError: action.payload,
      }
      case types.SET_CONTINUAR_EXAMEN: {
        const { continuar } = action;
        return {
          ...state,
          continuarExamen: continuar,
        }
      }
      case types.POST_GUARDAR_EXAMEN_BEGINS: {
        return {
          ...state,
          guardarExamenStatusFetching: true,
          guardarExamenStatusError: null,
        }
      }
      case types.POST_GUARDAR_EXAMEN_SUCCESS: {
        const data = action.payload;
        return {
          ...state,
          guardarExamenStatus: data.status,
          guardarExamenStatusData: data.data,
          guardarExamenStatusFetching: false,
          guardarExamenStatusError: null,
          examenGuardado: null,
        }
      }
      case types.POST_GUARDAR_EXAMEN_FAILURE:
        return { 
          ...state,
          guardarExamenStatusFetching: false,
          guardarExamenStatusError: action.payload,
      }
      case types.RESET_POST_GUARDAR_EXAMEN:
        return { 
          ...state,
          guardarExamenStatus: null,
          guardarExamenStatusData: null,
          guardarExamenStatusFetching: false,
          guardarExamenStatusError: null,
      }
      case types.ELIMINAR_EXAMEN_GUARDADO_BEGINS: {
        return {
          ...state,
          eliminarExamenStatusFetching: true,
          eliminarExamenStatusError: null,
        }
      }
      case types.ELIMINAR_EXAMEN_GUARDADO_SUCCESS: {
        const data = action.payload;
        return {
          ...state,
          eliminarExamenStatus: data.status,
          eliminarExamenStatusData: data.data,
          eliminarExamenStatusFetching: false,
          eliminarExamenStatusError: null,
          checkExamenGuardado: false,
        }
      }
      case types.ELIMINAR_EXAMEN_GUARDADO_FAILURE:
        return { 
          ...state,
          eliminarExamenStatusFetching: false,
          eliminarExamenStatusError: action.payload,
      }
      case types.RESET_ELIMINAR_EXAMEN_GUARDADO:
        return { 
          ...state,
          eliminarExamenStatus: null,
          eliminarExamenStatusData: null,
          eliminarExamenStatusFetching: false,
          eliminarExamenStatusError: null,
      }
    
  default:
    return state
  }
}

export const actions = {

  getExamenes: (options = null) => ({ type: types.GET_EXAMENES_BEGINS, options }),
  successGetExamenes: data => ({ type: types.GET_EXAMENES_SUCCESS, payload: data, }),
  errorGetExamenes: error => ({ type: types.GET_EXAMENES_FAILURE, payload: error, }),
  updateExamenes: (data, method) => ({ type: types.GET_EXAMENES_UPDATE, payload: { data, method }, }),

  postExamenes: examen => ({ type: types.POST_EXAMENES_BEGINS, examen }),
  successPostExamenes: data => ({ type: types.POST_EXAMENES_SUCCESS, payload: data, }),
  errorPostExamenes: error => ({ type: types.POST_EXAMENES_FAILURE, payload: error, }),
  resetPostExamenes: () => ({ type: types.RESET_POST_EXAMENES }),

  editExamenes: examen => ({ type: types.EDIT_EXAMENES_BEGINS, examen }),
  successEditExamenes: data => ({ type: types.EDIT_EXAMENES_SUCCESS, payload: data, }),
  errorEditExamenes: error => ({ type: types.EDIT_EXAMENES_FAILURE, payload: error, }),
  resetEditExamenes: () => ({ type: types.RESET_EDIT_EXAMENES }),

  deleteExamenes: (examen, options = null) => ({ type: types.DELETE_EXAMENES_BEGINS, examen, options }),
  successDeleteExamenes: data => ({ type: types.DELETE_EXAMENES_SUCCESS, payload: data, }),
  errorDeleteExamenes: error => ({ type: types.DELETE_EXAMENES_FAILURE, payload: error, }),
  resetDeleteExamenes: () => ({ type: types.RESET_DELETE_EXAMENES }),

  updateExamen: examen => ({ type: types.UPDATE_EXAMEN_BEGIN, examen }),
  successUpdateExamen: data => ({ type: types.UPDATE_EXAMEN_SUCCESS, payload: data, }),
  errorUpdateExamen: error => ({ type: types.UPDATE_EXAMEN_FAILURE, payload: error, }),
  resetUpdateExamen: () => ({ type: types.RESET_UPDATE_EXAMEN }),

  getVisibilidadExterna: idExamen => ({ type: types.GET_VISIBILIDAD_EXTERNA_BEGINS, idExamen }),
  successGetVisibilidadExterna: data => ({ type: types.GET_VISIBILIDAD_EXTERNA_SUCCESS, payload: data, }),
  errorGetVisibilidadExterna: error => ({ type: types.GET_VISIBILIDAD_EXTERNA_FAILURE, payload: error, }),
  resetGetVisibilidadExterna: () => ({ type: types.RESET_GET_VISIBILIDAD_EXTERNA }),

  batchGetVisibilidadExterna: idsExamenes => ({ type: types.BATCH_GET_VISIBILIDAD_EXTERNA_BEGINS, idsExamenes }),
  successBatchGetVisibilidadExterna: data => ({ type: types.BATCH_GET_VISIBILIDAD_EXTERNA_SUCCESS, payload: data, }),
  errorBatchGetVisibilidadExterna: error => ({ type: types.BATCH_GET_VISIBILIDAD_EXTERNA_FAILURE, payload: error, }),
  resetBatchGetVisibilidadExterna: () => ({ type: types.RESET_BATCH_GET_VISIBILIDAD_EXTERNA }),

  updateVisibilidadExterna: payload => ({ type: types.UPDATE_VISIBILIDAD_EXTERNA_BEGIN, payload }),
  successUpdateVisibilidadExterna: data => ({ type: types.UPDATE_VISIBILIDAD_EXTERNA_SUCCESS, payload: data, }),
  errorUpdateVisibilidadExterna: error => ({ type: types.UPDATE_VISIBILIDAD_EXTERNA_FAILURE, payload: error, }),
  resetUpdateVisibilidadExterna: () => ({ type: types.RESET_UPDATE_VISIBILIDAD_EXTERNA }),

  batchUpdateVisibilidadExterna: payload => ({ type: types.BATCH_UPDATE_VISIBILIDAD_EXTERNA_BEGIN, payload }),
  successBatchUpdateVisibilidadExterna: data => ({ type: types.BATCH_UPDATE_VISIBILIDAD_EXTERNA_SUCCESS, payload: data, }),
  errorBatchUpdateVisibilidadExterna: error => ({ type: types.BATCH_UPDATE_VISIBILIDAD_EXTERNA_FAILURE, payload: error, }),
  resetBatchUpdateVisibilidadExterna: () => ({ type: types.RESET_BATCH_UPDATE_VISIBILIDAD_EXTERNA }),

  postSubirExamen: examen => ({ type: types.POST_SUBIR_EXAMEN_BEGINS, examen }),
  successPostSubirExamen: data => ({ type: types.POST_SUBIR_EXAMEN_SUCCESS, payload: data, }),
  errorPostSubirExamen: error => ({ type: types.POST_SUBIR_EXAMEN_FAILURE, payload: error, }),
  resetPostSubirExamen: () => ({ type: types.RESET_POST_SUBIR_EXAMEN }),

  postSubirExamenesBatch: (examenes, progress = null) => ({ type: types.POST_SUBIR_EXAMENES_BATCH_BEGINS, examenes, progress }),
  progressPostSubirExamenesBatch: progress => ({ type: types.POST_SUBIR_EXAMENES_BATCH_PROGRESS, payload: progress, }),
  successPostSubirExamenesBatch: data => ({ type: types.POST_SUBIR_EXAMENES_BATCH_SUCCESS, payload: data, }),
  errorPostSubirExamenesBatch: error => ({ type: types.POST_SUBIR_EXAMENES_BATCH_FAILURE, payload: error, }),
  resetPostSubirExamenesBatch: () => ({ type: types.RESET_POST_SUBIR_EXAMENES_BATCH }),

  getExamenesAcademiaUsuario: () => ({ type: types.GET_EXAMENES_ACADEMIA_USUARIO_BEGINS }),
  successGetExamenesAcademiaUsuario: data => ({ type: types.GET_EXAMENES_ACADEMIA_USUARIO_SUCCESS, payload: data, }),
  errorGetExamenesAcademiaUsuario: error => ({ type: types.GET_EXAMENES_ACADEMIA_USUARIO_FAILURE, payload: error, }),

  checkExamenGuardado: () => ({ type: types.CHECK_EXAMEN_GUARDADO_BEGINS }),
  successCheckExamenGuardado: data => ({ type: types.CHECK_EXAMEN_GUARDADO_SUCCESS, payload: data, }),
  errorCheckExamenGuardado: error => ({ type: types.CHECK_EXAMEN_GUARDADO_FAILURE, payload: error, }),

  getExamenGuardado: () => ({ type: types.GET_EXAMEN_GUARDADO_BEGINS }),
  successGetExamenGuardado: data => ({ type: types.GET_EXAMEN_GUARDADO_SUCCESS, payload: data, }),
  errorGetExamenGuardado: error => ({ type: types.GET_EXAMEN_GUARDADO_FAILURE, payload: error, }),
  setContinuarExamen: continuar => ({ type: types.SET_CONTINUAR_EXAMEN, continuar}),

  postGuardarExamen: (examen, isErroneas, modo, nombre) => ({ type: types.POST_GUARDAR_EXAMEN_BEGINS, examen, isErroneas, modo, nombre }),
  successPostGuardarExamen: data => ({ type: types.POST_GUARDAR_EXAMEN_SUCCESS, payload: data, }),
  errorPostGuardarExamen: error => ({ type: types.POST_GUARDAR_EXAMEN_FAILURE, payload: error, }),
  resetPostGuardarExamen: () => ({ type: types.RESET_POST_GUARDAR_EXAMEN }),

  eliminarExamenGuardado: examen => ({ type: types.ELIMINAR_EXAMEN_GUARDADO_BEGINS, examen }),
  successEliminarExamenGuardado: data => ({ type: types.ELIMINAR_EXAMEN_GUARDADO_SUCCESS, payload: data, }),
  errorEliminarExamenGuardado: error => ({ type: types.ELIMINAR_EXAMEN_GUARDADO_FAILURE, payload: error, }),
  resetEliminarExamenGuardado: () => ({ type: types.RESET_ELIMINAR_EXAMEN_GUARDADO }),
}

export default ExamenesReducer;